export enum PipelineType {
    Deals = 'deals',
    IOIs = 'iois',
    ArrangerPipeline = 'arrangerPipeline'
}
